import React from 'react'
import PersonIcon from '@mui/icons-material/Person';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Tab, Tabs, Box, Typography } from '@mui/material';
import UserTimeSheet from '../components/UserTimeSheet';
import GroupTimeSheet from '../components/GroupTimeSheet';
function ViewTimeSheet() {
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <Box>
     
            <Box sx={{ mt: "2rem" }}>
                {value === 0 && <UserTimeSheet value={value} />}
                {/* {value === 1 && <GroupTimeSheet value={value} />} */}
            </Box>
        </Box>
    )
}

export default ViewTimeSheet